import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=2a1a78fe&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=2a1a78fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a78fe",
  null
  
)

export default component.exports